import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { IDocument } from '@common/models/Document/IDocument';
import { DialogService } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-document-summary-sidebar',
  templateUrl: './document-summary-sidebar.component.html',
  styleUrls: ['./document-summary-sidebar.component.scss'],
  providers: [DialogService]
})
export class DocumentSummarySidebarComponent implements OnChanges {
  @Input() sidebarVisible: boolean;
  @Input() header:string;
  @Input() summaryData: string;
  @Input() documentName:string;

  @Input() documentModel: IDocument;
  
  @Output() emitSidebarUpdate = new EventEmitter<boolean>();

  constructor(public dialogService: DialogService) { }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['summaryData'] && this.header==='Summary') {
      this.documentModel=null;
    }
  }

  onCloseSidebar(){
    this.emitSidebarUpdate.emit(false)
  }

}
